import { render, staticRenderFns } from "./modules-card.vue?vue&type=template&id=27f59d5a&scoped=true&"
import script from "./modules-card.vue?vue&type=script&lang=js&"
export * from "./modules-card.vue?vue&type=script&lang=js&"
import style0 from "./modules-card.vue?vue&type=style&index=0&id=27f59d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f59d5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VSwitch})
